import { Box, Notification, Typography } from "@drone-js/core";
import { VStack } from "apps/commons/components/Stack";
import { usePropertySelectionViewModelValue } from "apps/propertySelection/propertySelectionViewModelAtom";
import { memo } from "react";

export const UnsupportedUrlNotification = memo(() => {
    const {
        inputUrlCms: { checkListingLink, copyPasteListingLinkFormat },
    } = usePropertySelectionViewModelValue();

    return (
        <Notification
            intent="error"
            asset={{
                id: "fill.symbol.triangle-exclamation",
            }}
            title={checkListingLink}
            description={
                <VStack gap="2">
                    <Typography variant="body-s">{copyPasteListingLinkFormat}</Typography>
                    <Box as="ul" ps="12" m="0">
                        <li>https://www.airbnb.com/...</li>
                        <li>https://www.booking.com/...</li>
                    </Box>
                </VStack>
            }
        />
    );
});
